<template>
  <div class="row no-gutters body">
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../../assets/pageloader.svg" class="pageloader" alt="pageloader">
    </div>
    <div class="col-12 pb-5 mb-4" v-if="!pageloader">
      <div class="row no-gutters">
        <div v-if="showSidemenu" class="mt-2 togglemenu">
          <togglemenu  class="mt-5"></togglemenu>
        </div>
        <div class="col-md-12 col-lg-12 middle-background main-card">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="col-12 mt-5 pt-5" v-if="joberrorcode && (joberrorcode=='1021' || joberrorcode=='1050')">
            <no-selected-job :joberrorcode="joberrorcode"></no-selected-job>
          </div>
          <div v-else>
          <div class="row no-gutters mt-5">
            <div class="col-12 pl-lg-5 pr-lg-5 pt-lg-4 pt-3">
                <div class="mt-lg-2 ml-2">
                    <div class="d-flex">
                        <div class="d-flex backgroundcolorblack borderadius12 p-1 pl-3 pr-3 ml-lg-3 ml-2 pointer menubtn" @click="openSideMenu">
                            <img src="../../assets/HamburgrMenuWhite.svg" alt="hamburger">
                            <span class="fontsize12 white ml-1">MENU</span>
                        </div>
                        <div class="d-flex backgroundcolor2 borderadius12 p-1 pl-3 pr-3 pointer ml-3" @click="NavToListofJobs">
                            <img src="../../assets/JobBack.svg" alt="back">
                            <span class="fontsize12 stylebold black ml-1">Back</span>
                        </div>
                        <div class="d-flex backgroundcolor2 borderadius12 p-1 pl-3 pr-3 pointer ml-3" @click="NavToListofJobs">
                            <img src="../../assets/HamburgrMenuList.svg" alt="list">
                            <span class="fontsize12 stylebold black ml-1 text-nowrap">List of Jobs</span>
                        </div>
                    </div>
                </div>
                <!-- <div v-for="(job, index) in jobsList" :key="index"> -->
                  <div class="card mr-3 ml-3 mb-3 mt-3">
                    <div class="p-2 d-flex">
                      <div class="ml-lg-3 mr-2">
                        <div class="backgroundcolor1 p-lg-2 borderradius10 mr-lg-2 mr-md-2 p-2 mt-1 text-center">
                            <img :src="jobDetails.companyLogoLink" v-if="jobDetails.companyLogoLink" width="60px" class="rounded-circle companyLogo loadingBgImg" alt="companylogo">
                          <img src="../../assets/Profile_placehlder.svg" v-else class="img-fluid rounded-circle" alt="companylogo">
                        </div>
                      </div>
                      <div class="col-lg-11 pl-0 pt-1 pr-1 pr-sm-0">
                        <div class="d-flex justify-content-between">
                          <div class="jobmainHead">
                            <div class="d-lg-flex d-md-flex">
                              <span class="fontsize24 black proximanova stylebold jobTitle">{{jobDetails.jobTitle}}</span>
                              <select 
                                name="jobStatus"
                                :id="'jobStatus'" 
                                class="fontsize12 borderadius12 ml-lg-4 ml-md-2 mt-2"
                                :class="{'backgroundcolor6 bordergreen stylebold green':jobDetails.jobActive==='ACTIVE', 'backgroundcolor7 red borderred stylebold':jobDetails.jobActive==='INACTIVE'}"
                                v-model="jobDetails.jobActive"
                                @change="changeJobActiveStatus(jobDetails, jobDetails.jobActive)">
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">In Active</option>
                              </select>
                              <select 
                                name="jobStatus"
                                :id="'jobStatus'" 
                                class="fontsize12 backgroundcolor2 borderadius12 pl-1 pr-1 p-1 ml-md-2 my-auto d-block d-lg-none"
                                v-model="activeJobTab"
                                @change="toggleJobApplicationsData()">
                                <option value="Received_Applications">Received Applications</option>
                                <option value="Requested_Resumes">Requested Resumes</option>
                              </select>
                            </div>
                            <span class="mt-2 jobmainSub">
                                <!-- <span class="fontsizemd black stylebold proximanova">{{jobDetails.creationD | moment("from", "now", true)}} ago</span> -->
                                <span class="fontsizemd black  proximanova-semibold">{{ jobDetails.creationD | moment("MMM Do YYYY, h:mm a") }}</span>
                                <span class="ml-2 mr-2 black60">-</span>
                                <span class="fontsizemd black60 proximanova">Hiring Within 7 days</span>
                            </span>
                          </div>
                          <div class="d-none d-md-none d-lg-block" >
                            <div class="d-flex justidy-content-end">
                              <select 
                                name="jobStatus"
                                :id="'jobStatus'" 
                                class="fontsize12 backgroundcolor2 jobbtn borderadius12 pl-1 pr-1 p-1 my-auto"
                                v-model="activeJobTab"
                                @change="toggleJobApplicationsData()">
                                <option value="Received_Applications">Received Applications</option>
                                <option value="Requested_Resumes">Requested Resumes</option>
                              </select>
                              <div class="d-flex backgroundcolor2 jobbtn borderadius12 p-1 pl-lg-3 pr-lg-3 pointer ml-lg-3" @click="OpenJobDetailsModal">
                                  <img src="../../assets/JobDetails.svg" width="16px" height="16px" class="my-auto" alt="details">
                                  <span class="fontsizemd stylebold black ml-2 text-nowrap mt-1 btntext my-auto">View Details</span>
                              </div>
                              <div class="d-flex backgroundcolor2 jobbtn borderadius12 p-1 pl-lg-3 pr-lg-3 pointer ml-lg-3 ml-md-3 ml-1" v-if="jobDetails && jobDetails.jobStatus !== 'DELETE'" @click="NavToEditJob">
                                  <img src="../../assets/Edit_Share.svg" width="16px" height="16px" class="my-auto" alt="edit">
                                  <span class="fontsizemd stylebold black ml-2 mt-1 btntext my-auto">Edit</span>
                              </div>
                              <div class="d-flex backgroundcolor2 jobbtn borderadius12 p-1 pl-lg-3 pr-lg-3 pointer ml-md-3 ml-lg-3 ml-1 mr-1" v-if="jobDetails && jobDetails.jobStatus !== 'DELETE'" @click="openDeleteJobModal">
                                  <img src="../../assets/JobDelete.svg" width="16px" height="16px" class="my-auto" alt="delete">
                                  <span class="fontsizemd stylebold black ml-2 mt-1 btntext my-auto">Delete</span>
                              </div>
                              <div class="d-flex backgroundcolor2 jobbtn borderadius12 p-1 pl-lg-3 pr-lg-3 pointer ml-md-3 ml-lg-3 ml-1 mr-1 mr-lg-3 mr-md-3" v-if="jobDetails && jobDetails.jobStatus !== 'DELETE'" v-popover:fooNA1 >
                                  <img src="../../assets/sharearrow.png" width="16px" height="16px" class="my-auto" alt="delete">
                                  <span class="fontsizemd stylebold black ml-2 mt-1 btntext my-auto">Share</span>
                              </div>
                              <popover  name="fooNA1"  class="postvideomenu postvideomenu1" id="jobmenu">
                                <div class="p-1">
                                  <div class="d-flex pl-2 ml-1 pointer actionlink" @click="shareJob(jobDetails)">
                                    <img src="../../assets/sharejob.png" width="20" height="20" class="my-auto" alt="edit">
                                    <span class="p-2 font14-opacity80 proximanova">Share</span>
                                  </div>
                                  <div class="d-flex pl-2 ml-1 pointer actionlink" @click="copyJobLink(jobDetails)">
                                    <img src="../../assets/hyperlink1.png" width="20" height="20" class="my-auto" alt="delete">
                                    <span class="p-2 font14-opacity80 proximanova">Copy link</span>
                                  </div>
                                </div>
                              </popover>
                            </div>
                          </div>
                          <div class="d-block d-md-block d-lg-none d-flex d-md-flex justify-content-end">
                            <img src="../../assets/horizontal_menu_icon.svg" width="20px" height="20px"  v-popover:fooNA class="mt-2 mr-2 pointer more_optionhoriz" alt="moremenu">
                              <popover  name="fooNA"  class="postvideomenu " id="jobmenu">
                                <div class="p-1">   
                                  <div class="d-flex pl-2 ml-1 action d-block d-lg-none" @click="OpenJobDetailsModal">
                                    <img src="../../assets/JobDetails.svg" class="img-fluid" alt="details">
                                    <span class="p-2 font14-opacity80 proximanova">View Details</span>
                                  </div>                                     
                                  <div class="d-flex pl-2 ml-1 action d-block d-lg-none" v-if="jobDetails && jobDetails.jobStatus !== 'DELETE'" @click="NavToEditJob">
                                    <img src="../../assets/Edit_Share.svg" class="img-fluid" alt="edit">
                                    <span class="p-2 font14-opacity80 proximanova">Edit</span>
                                  </div>
                                  <div class="d-flex pl-2 ml-1 action d-block d-lg-none" v-if="jobDetails && jobDetails.jobStatus !== 'DELETE'" @click="openDeleteJobModal">
                                    <img src="../../assets/JobDelete.svg" class="img-fluid" alt="delete">
                                    <span class="p-2 font14-opacity80 proximanova">Delete</span>
                                  </div>
                                  <div class="d-flex pl-2 ml-1 action" @click="shareJob(jobDetails)">
                                    <img src="../../assets/sharejob.png" width="20" height="20" class="my-auto" alt="edit">
                                    <span class="p-2 font14-opacity80 proximanova">Share</span>
                                  </div>
                                  <div class="d-flex pl-2 ml-1 action" @click="copyJobLink(jobDetails)">
                                    <img src="../../assets/hyperlink1.png" width="20" height="20" class="my-auto" alt="delete">
                                    <span class="p-2 font14-opacity80 proximanova">Copy link</span>
                                  </div>
                                </div>
                              </popover>
                          </div>
                        </div>
                        <div class="d-lg-flex">
                            <span class="fontsize16 black proximanova">{{companyName}}</span>
                            <!-- <span class="ml-md-2 ml-1 mr-1 ml-lg-3 mr-lg-3 black60">|</span>
                            <span class="fontsizemd black60 proximanova mt-1">{{job.type}}</span> -->
                            <span class="ml-md-2 ml-1 mr-1 ml-lg-3 mr-lg-3 black60">|</span>
                            <span class="fontsizemd black60 proximanova mt-1" v-if="jobDetails.country">{{jobDetails.country.countryName}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="borderbottom"></div>
                    <div class=" d-flex mobileview flex-nowrap ml-3 mr-3 p-1 pt-2 pb-2" v-if="activeJobTab=='Requested_Resumes'">
                      <div class="p-1 pl-2 pr-2 mr-md-3 d-lg-flex d-md-flex backgroundcolor1 mouseoverjobsection"
                        :class="{'selectedBackground borderbottomblue' :selectedRequestSection === 'Total'}"
                        @click="getRequestResumesListByStatus('Total')">
                        <div>
                          <img src="../../assets/JobTotalRecieved.svg"  class="img-fluid" alt="received">
                        </div>
                        <div class="d-flex flex-column ml-ld-2 ml-md-2">
                          <span class="d-flex justify-content-between">
                            <span class="fontsizemd black60 proximanova stylebold mt-1 text-nowrap">Total Requests</span><span class="dot ml-2"></span>
                          </span>
                          <span class="fontsize16 black proximanova" v-if="jobRequestResumeDetails">{{jobRequestResumeDetails.totalResumeRequestsCount}}</span>
                          <span class="fontsize16 black proximanova" v-else>0</span>
                        </div>
                      </div>
                      <div class="p-1 pl-2 pl-lg-3 pr-2 mr-md-3 d-lg-flex d-md-flex backgroundcolor1 mouseoverjobsection"
                        :class="{'selectedBackground borderbottomblue' :selectedRequestSection === 'Requested'}"
                        @click="getRequestResumesListByStatus('Requested')">
                        <div>
                          <img src="../../assets/requested.svg"  class="img-fluid" alt="received">
                        </div>
                        <div class="d-flex flex-column ml-ld-2 ml-md-2">
                          <span class="d-flex justify-content-between">
                            <span class="fontsizemd black60 proximanova stylebold mt-1 text-nowrap">Requested</span><span class="ml-2"></span>
                          </span>
                          <span class="fontsize16 black proximanova" v-if="jobRequestResumeDetails">{{jobRequestResumeDetails.requestedResumesCount}}</span>
                          <span class="fontsize16 black proximanova" v-else>0</span>
                        </div>
                      </div>
                      <div class="p-1 pl-2 pl-lg-3 pr-2 mr-md-3 d-lg-flex d-md-flex backgroundcolor1 mouseoverjobsection"
                        :class="{'selectedBackground borderbottomblue' :selectedRequestSection === 'Accepted'}" 
                        @click="getRequestResumesListByStatus('Accepted')">
                        <div>
                          <img src="../../assets/JobSelected.svg"  class="img-fluid" alt="selected">
                        </div>
                        <div class="d-flex flex-column ml-ld-2 ml-md-2">
                          <span class="fontsizemd black60 proximanova stylebold mt-1">Accepted</span>
                          <span class="fontsize16 black proximanova" v-if="jobRequestResumeDetails">{{jobRequestResumeDetails.acceptedRequestedResumesCount}}</span>
                          <span class="fontsize16 black proximanova" v-else>0</span>
                        </div>
                      </div>
                      <div class="p-1 pl-2 pl-lg-3 pr-2 mr-md-3 d-lg-flex d-md-flex backgroundcolor1 mouseoverjobsection"
                        :class="{'selectedBackground borderbottomblue' :selectedRequestSection === 'Declined'}"
                        @click="getRequestResumesListByStatus('Declined')">
                        <div>
                          <img src="../../assets/JobDisqualified.svg"  class="img-fluid" alt="disqualified">
                        </div>
                        <div class="d-flex flex-column ml-ld-2 ml-md-2">
                          <span class="fontsizemd black60 proximanova stylebold mt-1">Declined</span>
                          <span class="fontsize16 black proximanova" v-if="jobRequestResumeDetails">{{jobRequestResumeDetails.declinedRequestedResumesCount}}</span>
                          <span class="fontsize16 black proximanova" v-else>0</span>
                        </div>
                      </div>
                    </div>
                    <div class=" d-flex mobileview flex-nowrap justify-content-between ml-3 mr-3 p-1 pt-2 pb-2" v-if="activeJobTab=='Received_Applications'">
                      <div class="p-1 pl-2 pr-2 mr-md-3 d-lg-flex d-md-flex backgroundcolor1 mouseoverjobsection"
                        :class="{'selectedBackground' :selectedJobStatisticsSection === 'Total' , 
                        'borderbottomblue' :(jobStatisticsDetails && jobStatisticsDetails.totalApplicants > 0 && jobStatisticsDetails.disqualifiedCount < 1 && jobStatisticsDetails.reviewCount < 1 && jobStatisticsDetails.assessmentCount < 1 && jobStatisticsDetails.shortlistedCount < 1 &&  jobStatisticsDetails.interviewCount < 1 && jobStatisticsDetails.selectedCount < 1 && jobStatisticsDetails.hiredCount < 1)}"
                        @click="getJobsListByStatus('Total')">
                        <div>
                          <img src="../../assets/JobTotalRecieved.svg"  class="img-fluid" alt="received">
                        </div>
                        <div class="d-flex flex-column ml-ld-2 ml-md-2">
                          <span class="d-flex justify-content-between">
                            <span class="fontsizemd black60 proximanova stylebold mt-1 text-nowrap">Total Received</span><span class="dot ml-2"></span>
                          </span>
                          <span class="fontsize16 black proximanova" v-if="jobStatisticsDetails">{{jobStatisticsDetails.totalApplicants}}</span>
                          <span class="fontsize16 black proximanova" v-else>0</span>
                        </div>
                      </div>
                      <div class="p-1 pl-2 pl-lg-3 pr-2 mr-md-3 d-lg-flex d-md-flex backgroundcolor1 mouseoverjobsection"
                        :class="{'selectedBackground' :selectedJobStatisticsSection === 'Disqualified' ,
                        'borderbottomblue' :(jobStatisticsDetails && jobStatisticsDetails.totalApplicants > 0 && jobStatisticsDetails.disqualifiedCount > 0 && jobStatisticsDetails.reviewCount < 1 && jobStatisticsDetails.assessmentCount < 1 && jobStatisticsDetails.shortlistedCount < 1 &&  jobStatisticsDetails.interviewCount < 1 && jobStatisticsDetails.selectedCount < 1 && jobStatisticsDetails.hiredCount < 1)}"
                        @click="getJobsListByStatus('Disqualified')">
                        <div>
                          <img src="../../assets/JobDisqualified.svg"  class="img-fluid" alt="disqualified">
                        </div>
                        <div class="d-flex flex-column ml-ld-2 ml-md-2">
                          <span class="fontsizemd black60 proximanova stylebold mt-1">Rejected</span>
                          <span class="fontsize16 black proximanova" v-if="jobStatisticsDetails">{{jobStatisticsDetails.disqualifiedCount}}</span>
                          <span class="fontsize16 black proximanova" v-else>0</span>
                        </div>
                      </div>
                      <div class="p-1 pl-2 pl-lg-3 pr-2 mr-md-3 d-lg-flex d-md-flex backgroundcolor1 mouseoverjobsection"
                        :class="{'selectedBackground' :selectedJobStatisticsSection === 'Review',
                        'borderbottomblue' :(jobStatisticsDetails && jobStatisticsDetails.totalApplicants > 0 && jobStatisticsDetails.disqualifiedCount >= 0 && jobStatisticsDetails.reviewCount > 0 && jobStatisticsDetails.assessmentCount < 1 && jobStatisticsDetails.shortlistedCount < 1 &&  jobStatisticsDetails.interviewCount < 1 && jobStatisticsDetails.selectedCount < 1 && jobStatisticsDetails.hiredCount < 1)}"
                        @click="getJobsListByStatus('Review')">
                        <div>
                          <img src="../../assets/JobReview.svg"  class="img-fluid" alt="review">
                        </div>
                        <div class="d-flex flex-column ml-ld-2 ml-md-2">
                          <span class="fontsizemd black60 proximanova stylebold mt-1">Review</span>
                          <span class="fontsize16 black proximanova" v-if="jobStatisticsDetails">{{jobStatisticsDetails.reviewCount}}</span>
                          <span class="fontsize16 black proximanova" v-else>0</span>
                        </div>
                      </div>
                      <div class="p-1 pl-2 pl-lg-3 pr-2 mr-md-3 d-lg-flex d-md-flex backgroundcolor1 mouseoverjobsection"
                        :class="{'selectedBackground' :selectedJobStatisticsSection === 'Assessment',
                        'borderbottomblue' :(jobStatisticsDetails && jobStatisticsDetails.totalApplicants > 0 && jobStatisticsDetails.disqualifiedCount >= 0 && jobStatisticsDetails.reviewCount >= 0 && jobStatisticsDetails.assessmentCount > 0 && jobStatisticsDetails.shortlistedCount < 1 &&  jobStatisticsDetails.interviewCount < 1 && jobStatisticsDetails.selectedCount < 1 && jobStatisticsDetails.hiredCount < 1)}"
                        @click="getJobsListByStatus('Assessment')">
                        <div>
                          <img src="../../assets/JobAssessment.svg"  class="img-fluid" alt="assessment">
                        </div>
                        <div class="d-flex flex-column ml-ld-2 ml-md-2">
                          <span class="fontsizemd black60 proximanova stylebold mt-1">Assessment</span>
                          <span class="fontsize16 black proximanova" v-if="jobStatisticsDetails">{{jobStatisticsDetails.assessmentCount}}</span>
                          <span class="fontsize16 black proximanova" v-else>0</span>
                        </div>
                      </div>
                      <div class="p-1 pl-2 pl-lg-3 pr-2 mr-md-3 d-lg-flex d-md-flex backgroundcolor1 mouseoverjobsection"
                        :class="{'selectedBackground' :selectedJobStatisticsSection === 'Shortlisted',
                        'borderbottomblue' :(jobStatisticsDetails && jobStatisticsDetails.totalApplicants > 0 && jobStatisticsDetails.disqualifiedCount >= 0 && jobStatisticsDetails.reviewCount >= 0 && jobStatisticsDetails.assessmentCount >= 0 && jobStatisticsDetails.shortlistedCount > 0 &&  jobStatisticsDetails.interviewCount < 1 && jobStatisticsDetails.selectedCount < 1 && jobStatisticsDetails.hiredCount < 1)}"
                        @click="getJobsListByStatus('Shortlisted')">
                        <div>
                          <img src="../../assets/JobShortlisted.svg"  class="img-fluid" alt="shortlisted">
                        </div>
                        <div class="d-flex flex-column ml-ld-2 ml-md-2">
                          <span class="fontsizemd black60 proximanova stylebold mt-1">Shortlisted</span>
                          <span class="fontsize16 black proximanova" v-if="jobStatisticsDetails">{{jobStatisticsDetails.shortlistedCount}}</span>
                          <span class="fontsize16 black proximanova" v-else>0</span>
                        </div>
                      </div>
                      <div class="p-1 pl-2 pl-lg-3 pr-2 mr-md-3 d-lg-flex d-md-flex backgroundcolor1 mouseoverjobsection"
                        :class="{'selectedBackground' :selectedJobStatisticsSection === 'Interview',
                        'borderbottomblue' :(jobStatisticsDetails && jobStatisticsDetails.totalApplicants > 0 && jobStatisticsDetails.disqualifiedCount >= 0 && jobStatisticsDetails.reviewCount >= 0 && jobStatisticsDetails.assessmentCount >= 0 && jobStatisticsDetails.shortlistedCount >= 0 &&  jobStatisticsDetails.interviewCount > 0 && jobStatisticsDetails.selectedCount < 1 && jobStatisticsDetails.hiredCount < 1)}" 
                        @click="getJobsListByStatus('Interview')">
                        <div>
                          <img src="../../assets/JobInterview.svg"  class="img-fluid" alt="interview">
                        </div>
                        <div class="d-flex flex-column ml-ld-2 ml-md-2">
                          <span class="fontsizemd black60 proximanova stylebold mt-1">Interview</span>
                          <span class="fontsize16 black proximanova" v-if="jobStatisticsDetails">{{jobStatisticsDetails.interviewCount}}</span>
                          <span class="fontsize16 black proximanova" v-else>0</span>
                        </div>
                      </div>
                      <div class="p-1 pl-2 pl-lg-3 pr-2 mr-md-3 d-lg-flex d-md-flex backgroundcolor1 mouseoverjobsection"
                        :class="{'selectedBackground' :selectedJobStatisticsSection === 'Selected',
                        'borderbottomblue' :(jobStatisticsDetails && jobStatisticsDetails.totalApplicants > 0 && jobStatisticsDetails.disqualifiedCount >= 0 &&  jobStatisticsDetails.reviewCount >= 0 && jobStatisticsDetails.assessmentCount >= 0 && jobStatisticsDetails.shortlistedCount >= 0 &&  jobStatisticsDetails.interviewCount >= 0 && jobStatisticsDetails.selectedCount > 0 && jobStatisticsDetails.hiredCount < 1)}" 
                        @click="getJobsListByStatus('Selected')">
                        <div>
                          <img src="../../assets/JobSelected.svg"  class="img-fluid" alt="selected">
                        </div>
                        <div class="d-flex flex-column ml-ld-2 ml-md-2">
                          <span class="fontsizemd black60 proximanova stylebold mt-1">Selected</span>
                          <span class="fontsize16 black proximanova" v-if="jobStatisticsDetails">{{jobStatisticsDetails.selectedCount}}</span>
                          <span class="fontsize16 black proximanova" v-else>0</span>
                        </div>
                      </div>
                      <div class="p-1 pl-2 pl-lg-3 pr-2 mr-md-3 d-lg-flex d-md-flex backgroundcolor1 mouseoverjobsection"
                        :class="{'selectedBackground' :selectedJobStatisticsSection === 'Hired',
                        'borderbottomblue' :(jobStatisticsDetails && jobStatisticsDetails.totalApplicants > 0 && jobStatisticsDetails.hiredCount > 0)}" 
                        @click="getJobsListByStatus('Hired')">
                        <div>
                          <img src="../../assets/JobHired.svg"  class="img-fluid" alt="hired">
                        </div>
                        <div class="d-flex flex-column ml-ld-2 ml-md-2">
                          <span class="fontsizemd black60 proximanova stylebold mt-1">Hired</span>
                          <span class="fontsize16 black proximanova" v-if="jobStatisticsDetails">{{jobStatisticsDetails.hiredCount}}</span>
                          <span class="fontsize16 black proximanova" v-else>0</span>
                        </div>
                      </div>
                    </div>
                  </div>
                <!-- </div> -->
            </div>
          </div>
          <div class="row no-gutters" v-if="!noApplicantsApplied">
            <div class="col-lg-12 pl-lg-5 pr-lg-5 col-12 d-flex" v-if="activeJobTab=='Received_Applications'">
              <div class="col-lg-4 col-md-12">
                <candidates-list></candidates-list>
              </div>
              <div class="col-8 pl-0 d-none d-lg-block">
                <candidate-details></candidate-details>
              </div>
            </div>
            <div class="col-lg-12 pl-lg-5 pr-lg-5 col-12 d-flex" v-if="activeJobTab=='Requested_Resumes'">
              <div class="col-lg-4 col-md-12">
                <user-resumes-list></user-resumes-list>
              </div>
              <div class="col-8 pl-0 d-none d-lg-block">
                <user-resume-data></user-resume-data>
              </div>
            </div>
          </div>
          <div class="row no-gutters" v-else>
            <div class="col-lg-12 pl-lg-5 pr-lg-5 col-12 d-flex">
              <div class="col-12 pl-0 pr-0">
                <no-jobs-available></no-jobs-available>
              </div>
            </div>
          </div>
          </div>
          <view-job-details v-if="viewJobDetails" :JobObject="JobObject" @closePreviewModal="closePreviewModal"></view-job-details>
          <delete-job-modal v-if="deleteJobModal" :deleteJobObject="deleteJobObject" @closeDeleteJobModal="closeDeleteJobModal"></delete-job-modal>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Popover from "vue-js-popover";
import httpbusiness from "@/js/http-business.js"
import httpjob from "@/js/http-postjob.js"
// import httpuserprofile from "@/js/http-userprofile.js"
import router from '../../router.js'
import CandidatesList from './CandidatesList.vue'
import CandidateDetails from './CandidateDetails.vue'
import UserResumesList from './UserResumesList.vue'
import UserResumeData from './UserResumeData.vue'
import viewJobDetails from '../postJob/PreviewJobModal.vue'
import togglemenu from '../../components/ToggleMenu.vue'
import deleteJobModal from '../../components/DeleteJobComponent.vue'
import noJobsAvailable from '../../components/NoJobsAvailable.vue'
import commonUtils from '@/js/common-utils.js'
import { bus } from "@/main.js";
import sessionUtils from "@/js/session-util.js";
import NoSelectedJob from "../../components/NoSelectedJob.vue"
Vue.use(Popover);
export default{
    components:{
      CandidatesList,
      CandidateDetails,
      UserResumesList,
      UserResumeData,
      viewJobDetails,
      deleteJobModal,
      noJobsAvailable,
      NoSelectedJob,
      togglemenu
    },
    data(){
        return{
            pageloader: true,
            activeJobTab : 'Received_Applications',
            businessAccountId : null,
            joberrorcode : null,
            viewJobDetails : false,
            deleteJobModal : false,
            jobId : null,
            JobObject : {},
            deleteJobObject : {
              jobId : ''
            },
            companyName : null,
            jobDetails : {},
            // companyDetails : {},
            noApplicantsApplied : false,
            jobStatisticsDetails : null,
            jobRequestResumeDetails: null,
            selectedJobStatisticsSection : 'Total',
            selectedRequestSection : 'Total',
            assessmentCount : 0,
            showSidemenu : false,
            jobsList : [
              {companyName : 'WorkNotion', type:'Professional Network services', country : 'USA', jobTitle : 'Product Designer', jobStatus:'active'},
            ]
        }
    },
    created (){
        bus.$on('IntecreaseCount', (data) => {
            this.assessmentCount = this.assessmentCount + 1
        })
        bus.$on('closeSideMenuJobDet', (data) => {
          this.showSidemenu = false
        }) 
    },
    methods:{
      //copy & share job link
      copyJobLink(jobObj) {
        commonUtils.copyJobLink(jobObj)
      },
      shareJob : function(jobObj){
        commonUtils.shareJob(jobObj)
      },
      toggleJobApplicationsData() {
        console.log("selected job tab : ", this.activeJobTab)
        this.noApplicantsApplied = false;
      },
      //this will invoke after click on back or list of jobs
        NavToListofJobs() {
            router.push({
                name : 'postedJobs'
            })
        },
        //this will invoke after click on edit job button
        NavToEditJob(){
          router.push({
            name : 'editjob'
          })
        },
        // this will invoke after changing job status from dropdown
      changeJobActiveStatus(job, jobactiveStatus){
        var vm = this;
        console.log(jobactiveStatus)
        httpjob.put('/postjob/updateJobActiveStatusById?jobId='+job.jobId+'&jobActive='+jobactiveStatus)
        .then((response) => {
          console.log(response)
          vm.$toast.success(response.data.errorMessage)
        }).catch((e) => {
          console.log(e)
          // vm.$toast.error(e.data.errorMessage)
          // this.displayAPIerrorModal = true;
        })
      },
        OpenJobDetailsModal() {
          //set data for view job modal
          this.JobObject = this.jobDetails;
          this.JobObject.selectedCity = this.JobObject.city;
          this.JobObject.selectedCountry = this.JobObject.country;
          this.JobObject.pinCode = this.JobObject.zipcode;
          this.JobObject.selectedPayScaleFrom = this.JobObject.payScaleFrom;
          this.JobObject.selectedPayScaleTo = this.JobObject.payScaleTo;
          this.JobObject.jobDescription = this.JobObject.jobDesc;
          this.JobObject.totalApplicantsCount = this.jobStatisticsDetails.totalApplicants;
          this.JobObject.type = 'view'
          console.log("jobobject : ", this.JobObject)
          this.viewJobDetails = true;
        },
        closePreviewModal(statusObj) {
          console.log(statusObj)
          this.viewJobDetails = false;
        },
        //this will invoke after click on delete btn on job details card
        openDeleteJobModal(){
          this.deleteJobObject.jobId = this.jobId
          this.deleteJobModal = true
        },
        //this will invoke after click on close btn in delete job modal component
        closeDeleteJobModal(statusObj) {
          this.deleteJobModal = false;
          if(statusObj === 'SUCCESS') {
            this.$router.go(-1);
          }
          console.log("delete job : ", statusObj)
        },
        // getCompanyData() {
        //     httpjob.get('/postjob/getcompanyProfileData?businessAccountId='+14)
        //     .then((response) => {
        //         this.companyDetails = response.data;
        //         console.log("company details : ", this.companyDetails)
        //     }).catch((e) => {
        //         console.log(e)
        //     })
        // },
        openSideMenu() {
          if(screen.width < 900) {
            bus.$emit('openToggleMenu', 'togglemenumedium')
          }else{
            this.showSidemenu = true;
            bus.$emit('openToggleMenu', 'togglemenularge')
          }
        },
        //this will invoke after component is mounted to get the job details based on job id
        getJobDetails(){
          // httpjob.get('/postjob/getJobDataById?jobId='+this.jobId)
          httpjob.get('/postjob/getJobDataByIds?jobId='+this.jobId+'&busineessAccId='+this.businessAccountId)
          .then((response) => {
            this.pageloader = false;
            console.log(response)
            if(response.data.errorCode != '1050' && response.data.errorCode != '1021'){
            this.jobDetails = response.data;
            if(this.jobDetails.jobStatus !== 'Inactive'){
              this.jobDetails.dropJobStatus = 'active'
            }else{
              this.jobDetails.dropJobStatus = 'inactive'
            }
            }else{
              this.joberrorcode = response.data.errorCode;
            }
          }).catch((e) => {
            console.log(e.response)
            this.pageloader = false;
          })
        },
        //this will invoke after click on any of the job status cards to display canidates list based on status card
        getJobsListByStatus(status){
          //this.noApplicantsApplied = false;
          this.selectedJobStatisticsSection = status;
          bus.$emit("getCandidatesByStatus", status)
        },
        getRequestResumesListByStatus(status) {
          this.selectedRequestSection = status;
          bus.$emit("getResumesByStatus", status)
        },
        //this will invoke after component is mounted to get the job statistics by job id
        getJobStatistics(){
          httpjob.get('/postjob/getEmpJobStatistics?jobId='+this.jobId)
          .then((response) => {
            console.log("job statistics : ", response)
            this.selectedJobStatisticsSection = 'Total'
            if(response.data && response.data.length>0){
              this.jobStatisticsDetails = response.data[0]
            }
            // setTimeout(() => {
            //   console.log("get total list")
            //   bus.$emit("getCandidatesByStatus", 'Total')  
            // }, 3000);
          }).catch((e) => {
            console.log(e.response)
          })
        },
        getJobRequestResumeAccessStatistics() {
          httpjob.get('/postjob/getResumeRequestCount?jobId='+this.jobId)
          .then((response) => {
            console.log("job resumes count : ", response)
            this.jobRequestResumeDetails = response.data;
          }).catch((e) => {
            console.log(e.response)
          })
        }
    },
    mounted() {
      window.scrollTo(0, 0)
      // this.getCompanyData()
      this.jobId = sessionUtils.getSelectedJobId();
      this.companyName = sessionUtils.getRecruiterCompanyName();
      this.businessAccountId = sessionUtils.getBusinessAccountId()
      this.getJobDetails()
      this.getJobStatistics()
      this.getJobRequestResumeAccessStatistics()
      bus.$on("updateJobApplicantsInformation", data => {
        if(data.status){
          console.log("in update statistics list")
          this.getJobStatistics()
        }
      })
      bus.$on("whenJobDontHaveApplicants", data => {
        if(data){
          this.noApplicantsApplied = true;
        }
      })
    },
    beforeDestroy(){
        bus.$off('openToggleMenu')
        bus.$off('getCandidatesByStatus')
        bus.$off('updateJobApplicantsInformation')
        bus.$off('whenJobDontHaveApplicants')
    },
}
</script>
<style scoped>
.loadingBgImg{
  background: transparent url('../../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.dropdown-position-bottom.postvideomenu {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width: 170px !important;
    left: unset !important;
  }
  .vue-popover.dropdown-position-bottom.postvideomenu:before {
    display: none !important;
  }
  .dropdown-position-bottom.postvideomenu1{
    right: 0;
  }
  .actionlink:hover{
    background: #dddfe5 !important;
    border-radius: 10px !important;
    cursor: pointer;
  }
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.selectedBackground{
  background-color: rgba(161, 166, 179,.2) !important;
}
.dot{
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background-color: tomato;
}
select > option{
  background-color: white;
  color: black;
}
.img-fluid{
  max-width: none;
}
.mouseoverjobsection{
    border-radius: 10px;
}
.mobileview{
  overflow: auto;
}
.togglemenu{
  margin-top: 8px !important;
}
.backgroundcolor6{
  height: 25px;
}
.btntext{
  display: none;
}
@media only screen and (max-width: 600px) {
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
  .mouseoverjobsection{
    width: 150px !important;
    margin-right: 10px;
    border-radius: 10px;
  }
  .jobbtn{
    height: 25px;
  }
  .companyLogo{
    width: 45px !important;
  }
  .jobTitle{
    font-size: 18px;
  }
}
@media (max-width : 400px){
  .jobbtn{
    height: 20px;
    width: 20px;
  }
}
@media only screen and (min-width: 800px) {
  .btntext{
    display: block;
  }
}
@media (max-width: 1000px){
  .menubtn{
    display: none !important;
  }
}
@media screen and (max-width: 1050px) and (min-width : 1020px) {
  .mouseoverjobsection{
    width: auto;
  }
  .jobbtn{
    height: 35px;
  }
  .jobmainHead{
    display: flex !important;
    flex-direction: column !important;
  }
  .jobmainSub{
    margin-left: 0 !important;
  }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
  .mouseoverjobsection{
    width: 200px;
    border-radius: 10px;
  }
  .jobbtn{
    height: 25px;
  }
}
@media screen and (min-width : 1400px) {
  .mouseoverjobsection{
    width: 11%;
}
}
</style>
